import { cn, RadioProps, useRadio, VisuallyHidden } from "@heroui/react";
import _ from "lodash";

export default function LanguageRadio(props: RadioProps) {
  const { Component, children, getBaseProps, getInputProps } = useRadio(props);

  return (
    <Component
      {...getBaseProps()}
      className={cn(
        "group inline-flex tap-highlight-transparent hover:opacity-70 active:opacity-50",
        "flex aspect-[6/1] h-auto w-full cursor-pointer flex-col items-center justify-center gap-4 rounded-md py-2",
        "bg-zinc-800 data-[selected=true]:bg-primary data-[selected=true]:text-white"
      )}
    >
      <VisuallyHidden>
        <input {...getInputProps()} />
      </VisuallyHidden>
      <div className="flex flex-col items-center justify-center gap-2 text-center">{children}</div>
    </Component>
  );
}
